import * as React from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import './MonthlyMileage.css';
import { DASHBOARD, PERSONAL_INSURANCE, COVER_CHILLI, WHATSAPP_LIVE_CHAT } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { photoData, confirmSubmission } from '../../actions/cameraActions';
import {
    CHILLI_MONTHLY_PHOTO_STEP1_HEADER, CHILLI_MONTHLY_PHOTO_STEP1_HEADER_SUBMITTED, CHILLI_MONTHLY_PHOTO_STEP2_HEADER,
    CHILLI_MONTHLY_PHOTO_STEP2_HEADER_SUBMITTED, CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION, CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION_SUBMITTED,
    CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION_UPLOADED, CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION_UPLOADED, CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION,
    CHILLI_MONTHLY_PHOTO_STEP3_HEADER, CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION_SUBMITTED, CHILLI_MONTHLY_RIGHT_CHECKMARK, CHILLI_MONTHLY_RIGHT_ARROW
} from '../../constants/copy';
import { setCustomerData } from '../../actions/profileActions';
import { showPhotoStepsScreen, showLoadingScreen, hideLoadingScreen } from '../../actions/fullscreenActions'
import { postToController } from '../../actions/apiActions';
import { navigateTo } from '../../actions/navigationActions';
import { logEvent } from '../../firebase/firebase';
import NeedHelp from '../BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';

class MonthlyMileageDashboard extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lon: 0,
        }
        this.handleClick = this.handleClick.bind(this);

        this.handlePhoto1Callback = this.handlePhoto1Callback.bind(this);
        this.handleStep1TryAgain = this.handleStep1TryAgain.bind(this);
        this.handleStep1Submit = this.handleStep1Submit.bind(this);
        this.handleStep1Next = this.handleStep1Next.bind(this);

        this.handlePhoto2Callback = this.handlePhoto2Callback.bind(this);
        this.handleStep2TryAgain = this.handleStep2TryAgain.bind(this);
        this.handleStep2Submit = this.handleStep2Submit.bind(this);
        this.handleStep2Next = this.handleStep2Next.bind(this);

        this.handleSubmitMonthlyMileage = this.handleSubmitMonthlyMileage.bind(this);
        this.handleMileageChange = this.handleMileageChange.bind(this);

        this.handleDashboardPhotoCardClick = this.handleDashboardPhotoCardClick.bind(this);
        this.handleMileagePhotoCardClick = this.handleMileagePhotoCardClick.bind(this);
        this.handleMileageUploadCardClick = this.handleMileageUploadCardClick.bind(this);

        this.getLocatLon = this.getLocatLon.bind(this);
    }

    componentDidMount() {
        navigator.geolocation.getCurrentPosition(function (position) {
        });
    }

    async handleDashboardPhotoCardClick() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            await this.props.dispatch(setCustomerData({ selfInspectionStep: 1 }));
            this.props.dispatch(showPhotoStepsScreen());
        }
    }

    async handleMileagePhotoCardClick() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            await this.props.dispatch(setCustomerData({ selfInspectionStep: 2 }));
            this.props.dispatch(showPhotoStepsScreen());
        }
    }

    async handleMileageUploadCardClick() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            await this.props.dispatch(setCustomerData({ selfInspectionStep: 3 }));
            this.props.dispatch(showPhotoStepsScreen());
        }
    }

    handleClick(id) {
        this.props.dispatchSetSelectedCover(id);
    }


    async getLocatLon() {
        await navigator.geolocation.getCurrentPosition(async (position) => {
            await this.setState({ lat: position.coords.latitude, lon: position.coords.longitude });
        });

        return new Promise((resolve, reject) => {
            setTimeout(resolve, 100, true);
        });
    }

    async handlePhoto1Callback(photo) {
        await this.props.dispatch(photoData({
            dashboardPhotoData: photo,
            dashboardHeader: CHILLI_MONTHLY_PHOTO_STEP1_HEADER,
            dashboardDescription: CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION_UPLOADED,
            dashboardDisplayStyle: "block",
            dashboardSubmitBtnDisplayStyle: "inline",
            dashboardNextBtnDisplayStyle: "none",
            dashboardCanSubmit: true,

            dashboardLat: this.state.lat,
            dashboardLon: this.state.lon,
            photoData: photo,
            photoAccepted: false,
            photoSubmitted: true,
        }));
    }

    async handleStep1TryAgain() {
        await this.props.dispatch(photoData({
            dashboardPhotoData: "",
            dashboardHeader: CHILLI_MONTHLY_PHOTO_STEP1_HEADER,
            dashboardDescription: CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION,
            dashboardDisplayStyle: "block",
            dashboardSubmitBtnDisplayStyle: "inline",
            dashboardNextBtnDisplayStyle: "none",
            dashboardCanSubmit: false,
            step1RightImageUrl: CHILLI_MONTHLY_RIGHT_ARROW,
            photoAccepted: false,
            photoSubmitted: false,
        }));
    }

    async handleStep1Submit() {
        await this.props.dispatch(photoData({
            dashboardHeader: CHILLI_MONTHLY_PHOTO_STEP1_HEADER_SUBMITTED,
            dashboardDescription: CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION_SUBMITTED,
            dashboardDisplayStyle: "block",
            dashboardSubmitBtnDisplayStyle: "none",
            dashboardNextBtnDisplayStyle: "inline",
            dashboardCanSubmit: true,

            dashboardLat: this.state.lat,
            dashboardLon: this.state.lon,
            photoAccepted: true,
            photoSubmitted: false,
        }));
    }

    async handleStep1Next() {
        await this.props.dispatch(photoData({
            dashboardDisplayStyle: "none",
            mileageDisplayStyle: "block",
            step1RightImageUrl: CHILLI_MONTHLY_RIGHT_CHECKMARK,
            step1Backround: "#fff",
            step2Backround: "#e6e6e6",
            photoData: null,
            photoAccepted: false,
            photoSubmitted: false,
        }));
    }

    async handlePhoto2Callback(photo) {
        await this.props.dispatch(photoData({
            mileagePhotoData: photo,
            mileageHeader: CHILLI_MONTHLY_PHOTO_STEP2_HEADER,
            mileageDescription: CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION_UPLOADED,
            mileageDisplayStyle: "block",
            mileageSubmitBtnDisplayStyle: "inline",
            mileageNextBtnDisplayStyle: "none",
            mileageCanSubmit: true,

            mileageLat: this.state.lat,
            mileageLon: this.state.lat,
            photoData: photo,
            photoAccepted: false,
            photoSubmitted: true,
        }));
    }

    async handleStep2TryAgain() {
        await this.props.dispatch(photoData({
            mileagePhotoData: "",
            mileageHeader: CHILLI_MONTHLY_PHOTO_STEP2_HEADER,
            mileageDescription: CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION,
            mileageDisplayStyle: "block",
            mileageSubmitBtnDisplayStyle: "inline",
            mileageNextBtnDisplayStyle: "none",
            mileageCanSubmit: false,
            step2RightImageUrl: CHILLI_MONTHLY_RIGHT_ARROW,
            step1Backround: "#fff",
            step2Backround: "#e6e6e6",
            photoAccepted: false,
            photoSubmitted: false,
        }));
    }

    async handleStep2Submit() {
        await this.props.dispatch(photoData({
            mileageHeader: CHILLI_MONTHLY_PHOTO_STEP2_HEADER_SUBMITTED,
            mileageDescription: CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION_SUBMITTED,
            mileageDisplayStyle: "block",
            mileageSubmitBtnDisplayStyle: "none",
            mileageNextBtnDisplayStyle: "inline",
            mileageCanSubmit: true,
            photoAccepted: true,
            photoSubmitted: false,
        }));
    }

    async handleStep2Next() {
        await this.props.dispatch(photoData({
            dashboardDisplayStyle: "none",
            mileageDisplayStyle: "none",
            mileageReadingDisplayStyle: "block",
            step2RightImageUrl: CHILLI_MONTHLY_RIGHT_CHECKMARK,
            step2Backround: "#fff",
            step3Backround: "#e6e6e6",
            photoData: null,
            photoAccepted: true,
            photoSubmitted: false,
        }));
    }

    async handleMileageChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.props.dispatch(photoData({ [name]: value }));
    }

    async handleSubmitMonthlyMileage() {
        try {
            var success = true;
            this.props.dispatch(showLoadingScreen());
            logEvent('SSP_Chilli_Odometer_Reading_Taken', {});
            await postToController(this.props.dispatch, 'SubmitOdoReading', JSON.stringify({
                RiskItemId: this.props.profile.selectedPersonalCover.riskItems[0].chilliDetails.riskItemId,
                OdoMeterReading: this.props.camera.totalMileage,
            })).then(async (response) => {
                var photoBatchId = response;

                await postToController(this.props.dispatch, 'SubmitOdoPhoto', JSON.stringify({
                    PhotoBatchId: photoBatchId,
                    RiskItemId: this.props.profile.selectedPersonalCover.riskItems[0].chilliDetails.riskItemId,
                    Data: this.props.camera.dashboardPhotoData,
                    PhotoType: 1,
                    IsLast: false,
                })).then((response) => { success = response.success })

                await postToController(this.props.dispatch, 'SubmitOdoPhoto', JSON.stringify({
                    PhotoBatchId: photoBatchId,
                    RiskItemId: this.props.profile.selectedPersonalCover.riskItems[0].chilliDetails.riskItemId,
                    Data: this.props.camera.mileagePhotoData,
                    PhotoType: 2,
                    IsLast: true,
                })).then((response) => { success = success && response.success })

                if (success) {
                    this.props.dispatch(confirmSubmission());
                }
            })
        }
        finally {
            this.props.dispatch(hideLoadingScreen());
            this.props.dispatch(navigateTo(PERSONAL_INSURANCE));
        }
    }

    render() {


        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Chilli" }]

        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: COVER_CHILLI, description: "Chilli" }]
        }

        let nav = <>
            <div>
                <div className="SubmitMonthly mb-3">
                    <div className="col-12">
                        <h3 className="Submit-monthly-title pt-2">Submit monthly mileage update</h3>
                        <p className="pColor pb-3">Send us your monthly mileage for your chilli car</p>
                    </div>
                </div>
                <div className="Steps mb-3 pl-3 pr-3" style={{ backgroundColor: this.props.camera.step1Backround }} onClick={this.handleDashboardPhotoCardClick}>
                    <div className="row pt-4">
                        <div className="col-3 pr-0">
                            <Image src="./images/ChilliDetails/MileageMonthly/icon-dashboard-grey.png" className="icon-dashboard" />
                        </div>
                        <div className="col-7">
                            <p>{CHILLI_MONTHLY_PHOTO_STEP1_HEADER}</p>
                        </div>
                        <div className="col-2 pl-1">
                            <Image src={this.props.camera.step1RightImageUrl} />
                        </div>
                    </div>
                </div>
                <div className="Steps mb-3 pl-3 pr-3" style={{ backgroundColor: this.props.camera.step2Backround }} onClick={this.handleMileagePhotoCardClick}>
                    <div className="row pt-4">
                        <div className="col-3 pr-0">
                            <Image src="./images/ChilliDetails/MileageMonthly/icon-odometer-photo-grey.png" className="icon-dashboard" />
                        </div>
                        <div className="col-7">
                            <p>{CHILLI_MONTHLY_PHOTO_STEP2_HEADER}</p>
                        </div>
                        <div className="col-2 pl-1">
                            <Image src={this.props.camera.step2RightImageUrl} />
                        </div>
                    </div>
                </div>
                <div className="Steps mb-3 pl-3 pr-3" style={{ backgroundColor: this.props.camera.step3Backround }} onClick={this.handleMileageUploadCardClick}>
                    <div className="row pt-4">
                        <div className="col-3 pr-0">
                            <Image src="./images/ChilliDetails/MileageMonthly/icon-odometer-reading-grey.png" className="icon-dashboard" />
                        </div>
                        <div className="col-7">
                            <p>{CHILLI_MONTHLY_PHOTO_STEP3_HEADER}</p>
                        </div>
                        <div className="col-2 pl-1">
                            <Image src={this.props.camera.step3RightImageUrl} />
                        </div>
                    </div>
                </div>
            </div>
        </>

        let submitMonthlyMileage = <div></div>
        if (this.props.camera.canSubmitMonthlyMileage === true) {
            submitMonthlyMileage = <>
                <div id="monthlyMileageButtonDiv" className="pb-5">
                    <button className="btn btn-solid-green btn-submit-monthly-mileage" onClick={this.handleSubmitMonthlyMileage}>Submit monthly mileage update</button>
                </div>
            </>
        }

        return (
            <div id="MonthlyMileageDashboard">
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Submit monthly mileage update" />
                <div className="d-none d-sm-none d-md-block d-xl-block">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="StepBox">
                                    <div id="SwitchToMobile">
                                        <div className="pt-3 border-bottom">
                                            <h3 className="carName mb-2">Monthly mileage update</h3>
                                            <p className="Step-Description mb-4">{this.props.profile.selectedPersonalCover.riskItems[0].description}</p>
                                        </div>
                                        <div className="inspection-container pt-3">
                                            <div className="inspection-left-div col-6 pl-0">
                                                <div className="pt-3 pb-2">
                                                    <h3 className="carName mb-3">Switch to your phone or tablet to continue</h3>
                                                    <p className="Step-Description"><b>Monthly mileage submission is only available on your phone or<br/> tablet</b></p>
                                                </div>
                                                <div id="ChilliSwitchMobile" className="pb-5">
                                                    <p className="mb-2">Follow these steps:</p>
                                                    <ul className="chilliInstructions">
                                                        <li><b>Step 1</b></li>
                                                        <li>On your phone or tablet, open your browser and search for<br/> ‘King Price self-service portal’.</li>
                                                        <br />
                                                        <li><b>Step 2</b></li>
                                                        <li>Tap on the link that comes up and the portal will open.</li>
                                                        <br />
                                                        <li><b>Step 3</b></li>
                                                        <li>Log into your account.</li>
                                                        <br />
                                                        <li><b>Step 4</b></li>
                                                        <li>On the menu, select ‘personal insurance’, then select the<br/> chilli car you want to capture your monthly mileage for.</li>
                                                        <br />
                                                        <li><b>Step 5</b></li>
                                                        <li>Tap on the ‘Submit monthly mileage update’ button to<br/> submit your monthly mileage.</li>
                                                    </ul>
                                                    <hr/>
                                                    <p>Or, you can upload your monthly mileage on our app. <a href="https://www.kingprice.co.za/app" target="_blank" >Click here</a> to download it.</p>
                                                </div>
                                            </div>
                                            <div className="inspection-right-div text-center col-6 pt-3">
                                                <Image className="inspection-cellphone" src="./images/ChilliDetails/MileageMonthly/Mileage-reading-mobile-example.png" alt={""} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <NeedHelp
                                    isMonthlyMileageDashboard={true}
                                    countryId={this.props.profile.countryId}
                                    claimsEmail={this.props.ssp.claims_email}
                                    contactUsTel={this.props.ssp.contactUs_tel}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-xl-none d-md-none">
                    <div className="mb-3 col-12 pl-0 pr-0">
                        {nav}
                    </div>
                    {submitMonthlyMileage}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        camera: state.camera,
        ssp: state.ssp
    }
}

export default connect(mapStateToProps)(MonthlyMileageDashboard);